import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

import initialState from "./initialState";
import organismSlice from "./organismSlice";
import neurodynamicsSlice from "./neurodynamicsSlice";
import connectomicsSlice from "./connectomicsSlice";
import compNeuroSlice from "./compNeuroSlice";
import projectionsSlice from "./projectionsSlice";
import share from "./share";

// -----------------------------------------------------------------------------

const useLinkStore = create(
  // using persist to load and save user data to sessionStorage
  persist(
    (set, get) => ({
      ...initialState,
      fetchedId: null,
      ...organismSlice(set),
      ...neurodynamicsSlice(set, get),
      ...connectomicsSlice(set, get),
      ...compNeuroSlice(set),
      ...projectionsSlice(set),
      ...share(get),

      // ----------------------------------------------------------------------------

      // SUMMARY CALCULATIONS
      // Calculate totals based on all values
      // getTimeToEmulation: () => get().yearsToCompletion + 1,

      // TODO: do some rounding or conversion between billions and millions, depending on expected values
      // getTotalCost: () => (1.2 - get().investment / 1000).toFixed(2),

      // ----------------------------------------------------------------------------

      // revert to the original JSON
      resetAll: () =>
        set((prev) => ({
          ...prev,
          ...prev.originalData,
        })),
    }),

    // name in sessionStorage
    {
      name: "brainEm-link-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

useLinkStore.subscribe((newState) => {
  console.log("Link store changed:", newState);
});

export default useLinkStore;
